// null orders will break this page anyway, no need to check isOrderRenderable
export default function orders(state = {}, action) {
  switch (action.type) {
    case 'RECEIVE_ORDER':
      return {
        ...state,
        [action.payload.number]: action.payload,
      }

    default:
      return state
  }
}

export function getShippedOrders(state) {
  return Object.values(state).reduce((shippedOrders, order) => {
    if (['shipped', 'fully_shipped'].includes(order.state)) {
      return { ...shippedOrders, [order.number]: order }
    }

    return shippedOrders
  }, {})
}
